import "twin.macro";

import { useState } from "react";
import { useLocation, useParams } from "react-router";

import { Settings } from "@mui/icons-material";
import { Button, Skeleton } from "@mui/material";

import { Contained } from "@components/StyledComponents";
import DistributorModal from "@features/distributors/DistributorModal";
import { useDistributorQuery } from "@features/distributors/data/distributorQueries";
import DistributorForm from "@features/distributors/form/DistributorForm";
import NewDistributorUserModal from "@features/distributors/form/NewDistributorUserModal";
import { Title } from "@features/ui";
import { useSetLocation } from "@services/reactRouterDom";
import DocTitle from "@utility/DocTitle";
import useRoleIs from "@utils/useRoleIs";

import ErrorPage from "./ErrorPage";

const DistributorSkeleton = () => {
  return (
    <div tw="grid gap-x-4 gap-y-6 lg:grid-cols-[2fr 1fr]">
      {/* Form side skeleton */}
      <div tw="space-y-4">
        <Skeleton variant="rounded" height={250} tw="rounded-xl" />
        <Skeleton variant="rounded" height={150} tw="rounded-xl" />
      </div>
      {/* Info tile skeleton */}
      <Skeleton variant="rounded" height={300} tw="rounded-xl" />
    </div>
  );
};
const DistributorPage = () => {
  const { id } = useParams();
  const { hash } = useLocation();
  const setLocation = useSetLocation();
  const roleIs = useRoleIs();
  const [showManageOrgsModal, setShowManageOrgsModal] = useState(false);

  const { data: distributor, isLoading, error } = useDistributorQuery(id);

  if (error) return <ErrorPage error={error} />;

  return (
    <>
      <DocTitle title={distributor?.name || "Distributor"} />
      <Contained tw="pb-6 w-full max-w-screen-lg mx-auto space-y-6">
        <div tw="flex justify-between items-center mb-4">
          <Title backUrl="/admin/distributors">
            {distributor?.name ? (
              `Editing ${distributor.name}`
            ) : (
              <Skeleton tw="w-48 h-8" />
            )}
          </Title>
          {roleIs("super") && distributor && (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => setShowManageOrgsModal(true)}
              endIcon={<Settings />}
            >
              Manage Distributor
            </Button>
          )}
        </div>

        {isLoading && <DistributorSkeleton />}
        {distributor && <DistributorForm distributor={distributor} />}
      </Contained>
      {hash === "#new-user" && distributor && (
        <NewDistributorUserModal
          onClose={() => setLocation({ hash: "" }, { replace: true })}
          distributor={distributor}
        />
      )}
      {showManageOrgsModal && distributor && (
        <DistributorModal
          distributor={distributor}
          onClose={() => setShowManageOrgsModal(false)}
        />
      )}
    </>
  );
};

export default DistributorPage;
